<template>
  <v-container fluid fill-height justify-center id="scrolling-techniques-7" class="overflow-y-auto" key="lang">
    <v-row class="max-w">
      <v-col>
        <div class="display-1 font-weight-medium mb-3 px-4">
          {{ $t('wybierz jezyk') }}
        </div>
        <v-list one-line class="transparent">
          <v-radio-group :mandatory="true" v-model="lang">
              <template v-for="(item, index) in langs">
                <v-list-item :key="index" @click="setLangAndGo(item.key)" class="br-3" :class="{selected: lang == item.key}">
                    <v-list-item-avatar class="text-uppercase">
                    {{ item.key }}
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-radio :value="item.key" :key="item.key" color="primary"></v-radio>
                    </v-list-item-action>
                </v-list-item>
              </template>
          </v-radio-group>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import { mapActions } from 'vuex'
export default {
  data: () => ({
    langs: [
      { key: 'pl', name: 'Polski' },
      { key: 'en', name: 'English' }
    ]
  }),
  computed: {
    lang: {
      get: function() {
        return this.$i18n.locale
      },
      set: function(val) {
        this.setLang(val)
      }
    },
  },
  methods: {
    ...mapActions([
      'setLang',
    ]),
    setLangAndGo(val) {
      this.setLang(val);
      //setTimeout(() => {
      this.$router.push({ path: '/settings' });
    }
  }
}
</script>

<style>

</style>